import { Component } from '@angular/core';
import { BlacklistIban } from '../../models/blacklist-iban.model';
import { BlacklistService } from '../../services/blacklist.service';
import { generatePagination } from '../../utils/pagination.utils';

@Component({
  selector: 'app-blacklist-ibans',
  standalone: false,
  templateUrl: './blacklist-ibans.component.html',
  styleUrl: './blacklist-ibans.component.css'
})
export class BlacklistIbansComponent {
  blacklistIbans: BlacklistIban[] = [];
  nextPageUrl: string | null = null;
  previousPageUrl: string | null = null;
  currentPage = 1;
  totalPages = 1;
  pageNumbers: any = [];
  searchQuery: string = '';
  submitted = false;
  iban: string = '';
  showModal = false;

  constructor(
    private backlistService: BlacklistService,
  ) {}

  ngOnInit() {
    this.loadBlacklists(this.currentPage);
  }

  reset() {
    this.blacklistIbans = [];
    this.nextPageUrl = null;
    this.previousPageUrl = null;
    this.currentPage = 1;
    this.totalPages = 1;
    this.pageNumbers = [];
  }

  loadBlacklists(page: number) {
    this.reset();
    this.submitted = true;

    this.backlistService.getBlacklistIbans(page, this.searchQuery).subscribe(
      response => {
        this.blacklistIbans = response.results;
        this.nextPageUrl = response.next;
        this.previousPageUrl = response.previous;
        this.currentPage = page;

        const itemsPerPage = 20;
        this.totalPages = Math.ceil(response.count / itemsPerPage);
        this.pageNumbers = generatePagination(this.currentPage, this.totalPages);
        this.submitted = false;
      }
    );
  }

  goToNextPage() {
    if (this.nextPageUrl) {
      const nextPage = this.getPageNumber(this.nextPageUrl);
      this.loadBlacklists(nextPage);
    }
  }

  goToPreviousPage() {
    if (this.previousPageUrl) {
      const prevPage = this.getPageNumber(this.previousPageUrl);
      this.loadBlacklists(prevPage);
    }
  }

  private getPageNumber(url: string): number {
    if (!url) return 1; // fallback if url is null

    const queryString = url.split('?')[1]; // get everything after "?"
    if (!queryString) return 1;

    const params = new URLSearchParams(queryString);
    const page = params.get('page');

    return page ? Number(page) : 1;
  }

  onSearchChange() {
    this.loadBlacklists(this.currentPage)
  }

  addBlacklistedIban() {
    this.backlistService.addBlacklistedIban(this.iban).subscribe(
      () => {
        this.loadBlacklists(this.currentPage);
        this.iban = '';
        this.showModal = false;
      }
    )
  }

  deleteBlacklistedIban(id: string) {
    if (window.confirm('Are you sure you want to delete this IBAN?')) {
      this.backlistService.deleteBlacklistedIban(id).subscribe(
        () => {
          this.loadBlacklists(this.currentPage);
        }
      )
    }
  }
}
